var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const customStickerCache = {
    get: (id, version) => __awaiter(void 0, void 0, void 0, function* () {
        let customSticker = customStickerMemoryCache.get(id);
        if (customSticker && (version === undefined || customSticker.version === version)) {
            return customSticker;
        }
        const db = yield getCacheDb();
        customSticker = yield db.get(id);
        if (customSticker && version && customSticker.version === version) {
            return customSticker;
        }
        if (!version) {
            return customSticker;
        }
        return undefined;
    }),
    set: (customSticker) => __awaiter(void 0, void 0, void 0, function* () {
        customStickerMemoryCache.set(customSticker.id, customSticker);
        const db = yield getCacheDb();
        yield db.set(customSticker);
    }),
};
const customStickerMemoryCache = new Map();
const getCacheDb = () => __awaiter(void 0, void 0, void 0, function* () {
    const { get, set } = yield import('idb-keyval');
    return {
        get: (id) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                return yield get(id);
            }
            catch (e) {
                console.error(e);
                return undefined;
            }
        }),
        set: (customSticker) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield set(customSticker.id, customSticker);
            }
            catch (e) {
                console.error(e);
            }
        }),
    };
});
//# sourceMappingURL=cache.js.map